import { _, helpers, ts } from '_core';

import { DraftParams, Params } from './types';
import { setUserDefinedOrderBar } from '../basket-compare-annualized-statistics/helpers';

export const formatSeriesName = (key: string, baskets: ts.types.basket.Basket[]) => {
  const currentBasket = baskets.find((b) => b.handle == key);
  if (currentBasket) return currentBasket.name;

  return key;
};

export const prepareAnnuStatsData = (
  fullData: ts.types.widgets.NestedBarWidgetData,
  params: Params,
  context: ts.types.basket.BasketAnalysisContext,
  baskets: ts.types.basket.Basket[]
) => {
  const localData = fullData.data;
  let newData = localData.map((group) => {
    const groupData = {} as ts.types.widgets.NestedBarData[0];
    Object.keys(group).forEach((innerKey) => {
      if (innerKey != 'category') {
        const formattedInnerKey = formatSeriesName(innerKey.split('-')[0], baskets);
        groupData[formattedInnerKey] = group[innerKey];
      }
    });
    groupData['category'] = group['category'];
    return groupData;
  });

  newData = setUserDefinedOrderBar(newData, context.basket_id, params.basket_ids, baskets);
  return {
    ...fullData,
    data: newData,
  } as ts.types.widgets.NestedBarWidgetData;
};

export const validate = (
  params: DraftParams,
  context: ts.types.backtestSet.BacktestSetAnalysisContext,
  _g: any,
  resources: ts.StoreState['resources']
) => {
  const basketCompareErrors = helpers.validations.validBasketCompare(params);
  if (!_.isEmpty(basketCompareErrors)) return basketCompareErrors;
  if (_.isEmpty(params.histories)) return ['Histories is a required field.'];

  if (params.with_benchmark) {
    const baskets = resources.baskets.filter((b) => params.basket_ids.includes(b.id));

    const basketFrequency = baskets[0]?.definition?.frequency;
    const allSameFrequency = baskets.every((basket) => basket.definition.frequency === basketFrequency);

    if (!allSameFrequency) {
      return ['Selected baskets must have the same frequency.'];
    }
  }

  return [];
};
